const Button = {
    baseStyle: {
        _hover: { textDecoration: "none" },
        _focus: { boxShadow: "none" }
    }
};

export default Button;